import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      // Show navbar after scrolling down a full section (100vh)
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight /2;
      
      if (scrollPosition > windowHeight) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Initial check in case page is loaded at a position
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <>
    <div className={`headline-logo ${visible ? 'hidden' : ''}`}>
      <img src="/ui/SignalTheory-black.png" alt="Signal Theory Logo" />
    </div>
      <nav className={`navbar ${visible ? 'visible' : ''}`} role="navigation" aria-label="Main navigation">
        <div className="navbar-container">
          <div className="navbar-logo">
            <a href="#main-content" aria-label="Signal Theory home">
              <img src="/ui/SignalTheory-LOGO-horizontal.png" alt="Signal Theory Logo" />
            </a>
          </div>
          <div className="navbar-links" role="menubar">
            <a href="#projects" role="menuitem" aria-describedby="projects-desc">Work</a>
            <a href="#contact" role="menuitem" aria-describedby="contact-desc">Contact</a>
          </div>
        </div>
        <div className="sr-only">
          <span id="projects-desc">View our portfolio of projects</span>
          <span id="contact-desc">Get in touch with our team</span>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
